export default __webpack_public_path__ + "static/media/Universe_ Fest 2.c288e2c4.png";